













import { defineComponent, toRefs, PropType } from '@vue/composition-api';
import AudienceSizeFlex from './index';

const name = 'ttam-audience-size-flex-compose';
export default defineComponent({
  name,
  components: {
    TtamAudienceSizeFlexMainTitle: AudienceSizeFlex.TtamAudienceSizeFlexMainTitle,
    TtamAudienceSizeFlexEstimateChart: AudienceSizeFlex.TtamAudienceSizeFlexEstimateChart,
    TtamAudienceSizeFlexEstimateNum: AudienceSizeFlex.TtamAudienceSizeFlexEstimateNum,
    TtamAudienceSizeFlexEstimateTip: AudienceSizeFlex.TtamAudienceSizeFlexEstimateTip,
  },
  props: {
    audienceEstimateScore: {
      // 0-5
      type: Number,
      default: 0,
    },
    audienceEstimateCount: {
      // "99,756,000-121,926,000"
      type: String,
      default: '',
    },
    audienceEstimateTips: {
      /*
      [
        {
         show: false,
         title: "Your audience size is very broad.",
         type: "warning",
        },
        {
          show: true,
          title: "To better protect user privacy, expand your estimated audience size in the United States to 1,000 users or more.",
          type: "error",
        }
        ...
      ]
       */
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {
      name,
    };
  },
});
